export const KEY_RIGHT_ARROW = 39
export const KEY_LEFT_ARROW = 37
export const KEY_UP_ARROW = 38
export const KEY_DOWN_ARROW = 40

export const LANGUAGE_ET = 'et'
export const LANGUAGE_EN = 'en'

export const PATH_MEDIA = '/media'
